/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import AddTaxRates from "../../../core/modals/settings/addtaxrates";
import EditTaxRates from "../../../core/modals/settings/edittaxrates";
import SettingsSideBar from "../settingssidebar";
import { Edit } from "react-feather";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../../core/pagination/datatable";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { canSee } from "../../../core/utils/permissions";
import {
  fetchTaxes,
  openModal,
  closeModal,
  openDeleteModal,
  closeDeleteModal,
  removeTax,
  addTaxe,
  editTax,
} from "../../../core/redux/tax.slice";
import TaxRateFormModal from "./taxRatesModal";
import StickyBar from "../../../core/common/StickyBar";
import { useTranslation } from "react-i18next";
const TaxRates = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { taxes, showModal, showDeleteModal, loading } = useSelector(
    (state) => state.tax,
  );
  const { user } = useSelector((state) => state.auth);
  const canDelete =
    canSee(user?.roles, "ADMIN") || canSee(user?.roles, "SUPERADMIN");
  const [selectedTax, setSelectedTax] = React.useState(null);
  const [taxToDelete, setTaxToDelete] = React.useState("");
  const [isEditMode, setIsEditMode] = React.useState(false);
  React.useEffect(() => {
    if (!taxes.length) {
      dispatch(fetchTaxes());
    }
  }, [dispatch, taxes]);

  const deleteTax = () => {
    dispatch(removeTax(taxToDelete));
  };

  const hideModal = () => {
    dispatch(closeModal());
  };

  const onFinish = (values) => {
    if (isEditMode) {
      dispatch(editTax({ id: selectedTax.taxId, tax: values }));
    } else {
      dispatch(addTaxe(values));
    }
  };

  const columns = [
    {
      title: t("taxes.title"),
      dataIndex: "taxName",
    },
    {
      title: t("taxes.percentage"),
      dataIndex: "taxPercent",
      render: (taxPercent) => `${(taxPercent * 100).toFixed(0)}%`,
    },
    {
      title: t("taxes.amount"),
      dataIndex: "taxAmount",
    },
    {
      title: t("taxes.actions"),
      dataIndex: "action",
      render: (_, record) => {
        return (
          <div className="action-table-data">
            <div className="edit-delete-action">
              <div className="input-block add-lists"></div>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => {
                  setIsEditMode(true);
                  dispatch(openModal());
                  setSelectedTax(record);
                }}
              >
                <Edit className="feather-edit" />
              </Link>

              {canDelete && (
                <Link
                  onClick={() => {
                    setTaxToDelete(record.taxId);
                    dispatch(openDeleteModal());
                  }}
                  className="p-2 d-flex align-items-center border rounded"
                  to="#"
                >
                  <i data-feather="trash-2" className="feather-trash-2" />
                </Link>
              )}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content settings-content">
          <StickyBar
            title={t("taxes.title")}
            count={taxes.length}
            actions={
              <Button className="btn-customized-primary">
                <Link
                  to="#"
                  onClick={() => {
                    setIsEditMode(false);
                    dispatch(openModal());
                  }}
                >
                  <i className="ti ti-circle-plus me-1" />
                { t("taxes.addTax")}
                </Link>
              </Button>
            }
          />

          <div className="row">
            <div className="col-xl-12">
              <div className="settings-wrapper d-flex">
                <SettingsSideBar />
               <div className="flex-fill w-50">
                  {showModal ? (
                    <TaxRateFormModal
                      loading={loading}
                      initialData={isEditMode ? selectedTax : {}}
                      isEdit={isEditMode}
                      onSubmit={onFinish}
                      onCancel={hideModal}
                    />
                  ) : (
                    <div className="card table-list-card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h4>{t("taxes.title")}</h4>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table
                            columns={columns}
                            dataSource={taxes.filter((tax) => tax.taxIsActive)}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      {/* <TaxRateFormModal
        loading={loading}
        initialData={isEditMode ? selectedTax : {}}
        isEdit={isEditMode}
        open={showModal}
        onSubmit={onFinish}
        onCancel={hideModal}
      /> */}

      <Modal
        onCancel={() => dispatch(closeDeleteModal())}
        open={showDeleteModal}
        footer=""
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                 { t("taxes.deleteTaxTitle")}
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                 { t("taxes.deleteTaxConfirm")}
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <Button
                    size="large"
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => dispatch(closeDeleteModal())}
                  >
                  { t("common.cancel")}
                  </Button>
                  <Button
                    size="large"
                    type="button"
                    loading={loading}
                    onClick={deleteTax}
                    className="btn btn-submit fs-13 fw-medium p-2 px-3"
                  >
                 { t("taxes.yesDelete")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TaxRates;
